export default function ServiceAreas() {
  const areas = [
    {
      id: 1,
      title: '集客DX',
      subtitle: '売上につながる流れをつくる',
      description: '集客は、広告を出すことだけではありません。自社のことを知らない人に、どう見つけてもらうか。見つけた人に、どう選んでもらうか。その前提を整えることが、集客DXの出発点です。',
      details: [
        'WebやSNSで、自社の情報がきちんと伝わっているかを確認する',
        'どんな人に来てほしいのかを言葉にする',
        '見つけてもらうための導線を整える'
      ],
      summary: '目指すのは、数を集めることではありません。自社を理解した上で問い合わせてもらえる状態を作り、結果として、事業に合った顧客と出会えるようにすることです。',
      icon: 'ri-megaphone-line',
      color: '#12335f',
      image: 'https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/7e6554bc98ffc45b020e07317fd839b9.png'
    },
    {
      title: '採用DX',
      subtitle: '選ばれる前提をつくる',
      description: '優秀な人材を採用するためには、求人を出す前に、自社がどう見られているかが重要になります。どんな会社なのか、何を大切にしているのかが伝わっていなければ、そもそも選択肢に入らないからです。',
      details: [
        'WebやSNSで、自社の考えや取り組みが伝わっているかを確認する',
        'どんな人に来てほしいのかを言葉にする',
        '求人情報と日常の発信にズレがないかを確認する'
      ],
      summary: '目指すのは、数を集める採用ではありません。自社を理解した上で応募してもらえる状態を作り、結果として、事業に合った人材と出会えるようにすることです。',
      icon: 'ri-team-line',
      color: '#037555',
      image: 'https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/ba43d7d0916f1e98b89e79974808223d.png'
    },
    {
      title: '業務改善DX',
      subtitle: '業務スピードを引き上げる',
      description: '業務に追われ、考える時間が取れない。作業に時間がかかり、本来やるべきことが後回しになっている。こうした状態が続くと、どれだけ施策を考えても実行が追いつきません。業務改善DXの目的は、業務を減らすことではありません。業務のスピードを上げ、判断と実行が早く回る状態を作ることです。',
      details: [
        '業務の流れを一度すべて確認する',
        '時間がかかっている作業を特定する',
        'デジタルで置き換えられる部分を切り分ける'
      ],
      summary: 'いきなり全部を変えることはしません。効果が出やすいところから手を入れ、現場のスピードが実感できる形で進めていきます。',
      icon: 'ri-speed-up-line',
      color: '#ea5614',
      image: 'https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/855a117d23f2ab9c8279347729ba6f9e.png'
    }
  ];

  return (
    <>
      <section id="service" className="py-24 lg:py-32 bg-[#f8fafc] relative overflow-hidden">
        {/* 背景装飾 */}
        <div className="absolute top-20 right-10 w-96 h-96 bg-[#12335f]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 left-10 w-80 h-80 bg-[#037555]/5 rounded-full blur-3xl"></div>
        
        <div className="max-w-6xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="text-center mb-16">
            {/* Serviceラベル */}
            <span className="inline-block px-5 py-2 bg-[#12335f]/10 text-[#12335f] text-sm font-medium rounded-full mb-6 tracking-wider">
              Service
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#12335f] mb-6">
              DXは特別ではない
            </h2>
            <p className="text-base lg:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
              デジポップブーストでは、DXを特定のツールや施策に限定せず、経営や現場の中で起きている課題をもとに、取り組むテーマを決めていきます。<br />
              支援の対象は、大きく分けて次の3つの領域です。
            </p>
          </div>

          <div className="space-y-16">
            {areas.map((area, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100">
                {/* タイトルヘッダー - 写真の外に独立配置 */}
                <div 
                  className="px-8 lg:px-10 py-6 flex items-center gap-5 border-b border-gray-100"
                  style={{ background: `linear-gradient(135deg, ${area.color}08, ${area.color}03)` }}
                >
                  <div 
                    className="w-14 h-14 flex items-center justify-center rounded-2xl shadow-lg flex-shrink-0"
                    style={{ backgroundColor: area.color }}
                  >
                    <i className={`${area.icon} text-2xl text-white`}></i>
                  </div>
                  <div>
                    <h3 
                      className="text-3xl lg:text-4xl font-black tracking-wide"
                      style={{ color: area.color }}
                    >
                      {area.title}
                    </h3>
                    <p className="text-sm lg:text-base font-bold text-gray-500 mt-1">
                      {area.subtitle}
                    </p>
                  </div>
                </div>

                {/* 画像とコンテンツ */}
                <div className={`grid lg:grid-cols-2`}>
                  {/* 画像 */}
                  <div className={`relative h-64 lg:h-auto lg:min-h-[320px] ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                    <img 
                      src={area.image}
                      alt={area.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  
                  {/* コンテンツ */}
                  <div className={`p-8 lg:p-10 flex flex-col justify-center ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                    <p className="text-base text-gray-700 leading-relaxed mb-6">
                      {area.description}
                    </p>

                    <div className="bg-gray-50 rounded-xl p-5 mb-6">
                      <ul className="space-y-3">
                        {area.details.map((detail, idx) => (
                          <li key={idx} className="flex items-start">
                            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                              <i className="ri-check-line text-lg" style={{ color: area.color }}></i>
                            </div>
                            <span className="text-sm text-gray-700 ml-2">{detail}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div 
                      className="rounded-lg p-5 border-l-4"
                      style={{ backgroundColor: `${area.color}08`, borderColor: area.color }}
                    >
                      <p className="text-sm text-gray-700 leading-relaxed">
                        {area.summary}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-br from-[#12335f] to-[#153577] p-10 lg:p-12 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
          <div className="relative z-10">
            <p className="text-base lg:text-lg text-white leading-loose mb-6">
              何から始めるか迷っている段階でも問題ありません。<br />
              無料診断で、今の状況を確認しながら、<br />
              <strong className="font-bold">優先して取り組むポイントを明確にします。</strong>
            </p>
          </div>
        </div>
      </section>

      <section id="flow" className="py-24 lg:py-32 bg-[#dce8f5] relative overflow-hidden">
        {/* 背景装飾 */}
        <div className="absolute top-40 left-20 w-72 h-72 bg-[#c5d9f0]/50 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#b8d4f0]/40 rounded-full blur-3xl"></div>
        
        <div className="max-w-5xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="text-center mb-16">
            {/* Flow of supportラベル */}
            <span className="inline-block px-5 py-2 bg-[#12335f]/10 text-[#12335f] text-sm font-medium rounded-full mb-6 tracking-wider">
              Flow of support
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#12335f] mb-6">
              ご支援の流れ
            </h2>
            <p className="text-base lg:text-lg text-gray-700 leading-loose max-w-4xl mx-auto">
              デジポップブーストは、思いついた施策をすぐに始めるわけではありません。
            </p>
            <p className="text-base lg:text-lg text-gray-700 leading-loose max-w-4xl mx-auto mt-4">
              まず状況を把握し、次に動ける形を作り、最後に社内で回る状態にしていきます。
            </p>
            <p className="text-base lg:text-lg text-[#153577] font-bold leading-loose max-w-4xl mx-auto mt-6">
              進め方は、状況整理 → 実行できる形にする → 社内で回すという3ステップです。
            </p>
          </div>

          <div className="space-y-6">
            {/* STEP1 */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 relative hover:shadow-xl transition-shadow overflow-hidden">
              <div className="grid lg:grid-cols-5">
                {/* イメージイラスト */}
                <div className="lg:col-span-2 relative h-56 lg:h-auto">
                  <img
                    src="https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/8085f3dd5f451186f7b2853aea98aa89.png"
                    alt="DX推進診断"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/20 lg:bg-gradient-to-l"></div>
                </div>
                
                {/* コンテンツ */}
                <div className="lg:col-span-3 p-8 lg:p-10">
                  <div className="flex items-center mb-5">
                    <div className="bg-gradient-to-br from-[#12335f] to-[#153577] text-white text-lg lg:text-xl font-bold px-8 py-3 rounded-full shadow-md">
                      STEP1
                    </div>
                    <h3 className="text-xl lg:text-2xl font-bold text-[#12335f] ml-4">
                      DX推進診断・整理
                    </h3>
                  </div>
                  <p className="text-base font-bold text-[#153577] mb-4">
                    「何から手をつけるべきか」をはっきりさせる
                  </p>
                  
                  <p className="text-sm lg:text-base text-gray-700 leading-relaxed mb-4">
                    最初に行うのは、現状の確認です。今やっている業務や取り組みを一つずつ確認しながら、どこに課題があるかを明確にしていきます。
                  </p>

                  <div className="bg-gray-50 rounded-xl p-4 mb-4">
                    <ul className="space-y-2">
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">現在の業務内容や体制についてお話を伺う</span>
                      </li>
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">困っていること、気になっていることを書き出す</span>
                      </li>
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">今すぐ着手すべきことと、後でもよいことを分ける</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-[#153577]/5 rounded-lg p-4 border-l-4 border-[#153577]">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      この段階で、「何が問題なのか」「なぜ進んでいないのか」が整理されます。<strong className="text-[#153577]">判断の軸と、最初の一手が見える状態</strong>を作る工程です。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 矢印1 */}
            <div className="flex justify-center py-2">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#12335f] to-[#037555] rounded-full shadow-lg">
                  <i className="ri-arrow-down-line text-white text-2xl"></i>
                </div>
              </div>
            </div>

            {/* STEP2 */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 relative hover:shadow-xl transition-shadow overflow-hidden">
              <div className="grid lg:grid-cols-5">
                {/* コンテンツ */}
                <div className="lg:col-span-3 p-8 lg:p-10 order-2 lg:order-1">
                  <div className="flex items-center mb-5">
                    <div className="bg-gradient-to-br from-[#037555] to-[#12335f] text-white text-lg lg:text-xl font-bold px-8 py-3 rounded-full shadow-md">
                      STEP2
                    </div>
                    <h3 className="text-xl lg:text-2xl font-bold text-[#12335f] ml-4">
                      設計・実行
                    </h3>
                  </div>
                  <p className="text-base font-bold text-[#153577] mb-4">
                    無理なく動かせる形にして、実際に試す
                  </p>
                  
                  <p className="text-sm lg:text-base text-gray-700 leading-relaxed mb-4">
                    整理した内容をもとに、現場で実行できる形に落とし込みます。大きな変更ではなく、今の業務の延長で進めることを前提にします。
                  </p>

                  <div className="bg-gray-50 rounded-xl p-4 mb-4">
                    <ul className="space-y-2">
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">取り組む内容と手順を具体的に決める</span>
                      </li>
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">誰が、どこまで担当するかを明確にする</span>
                      </li>
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">実際の業務の中で試しながら進める</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-[#037555]/5 rounded-lg p-4 border-l-4 border-[#037555]">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      ここでは、「できそうか」ではなく、<strong className="text-[#153577]">「無理なく続けられるか」を基準に進めます。</strong>
                    </p>
                  </div>
                </div>
                
                {/* イメージイラスト */}
                <div className="lg:col-span-2 relative h-56 lg:h-auto order-1 lg:order-2">
                  <img
                    src="https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/46a0a346b3eafa8e6cf2af32f4feeadb.png"
                    alt="設計・実行"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-l from-transparent to-white/20 lg:bg-gradient-to-r"></div>
                </div>
              </div>
            </div>

            {/* 矢印2 */}
            <div className="flex justify-center py-2">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#037555] to-[#ea5614] rounded-full shadow-lg">
                  <i className="ri-arrow-down-line text-white text-2xl"></i>
                </div>
              </div>
            </div>

            {/* STEP3 */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 relative hover:shadow-xl transition-shadow overflow-hidden">
              <div className="grid lg:grid-cols-5">
                {/* イメージイラスト */}
                <div className="lg:col-span-2 relative h-56 lg:h-auto">
                  <img
                    src="https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/816866f395d070c0990525b93ac9a134.png"
                    alt="改善・定着"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/20 lg:bg-gradient-to-l"></div>
                </div>
                
                {/* コンテンツ */}
                <div className="lg:col-span-3 p-8 lg:p-10">
                  <div className="flex items-center mb-5">
                    <div className="bg-gradient-to-br from-[#ea5614] to-[#9a1e23] text-white text-lg lg:text-xl font-bold px-8 py-3 rounded-full shadow-md">
                      STEP3
                    </div>
                    <h3 className="text-xl lg:text-2xl font-bold text-[#12335f] ml-4">
                      改善・定着
                    </h3>
                  </div>
                  <p className="text-base font-bold text-[#153577] mb-4">
                    社内で回る形にしていく
                  </p>
                  
                  <p className="text-sm lg:text-base text-gray-700 leading-relaxed mb-4">
                    試して終わりではなく、実際に回してみた結果をもとに調整します。外部に頼らなくても判断できる状態を目指します。
                  </p>

                  <div className="bg-gray-50 rounded-xl p-4 mb-4">
                    <ul className="space-y-2">
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">実際に使ってみた感触を確認する</span>
                      </li>
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">うまくいかない部分を見直す</span>
                      </li>
                      <li className="flex items-start">
                        <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                          <i className="ri-checkbox-circle-fill text-[#037555] text-base"></i>
                        </div>
                        <span className="text-sm text-gray-700 ml-2">社内で同じやり方を再現できる形にする</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-[#ea5614]/5 rounded-lg p-4 border-l-4 border-[#ea5614]">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      この工程で、「担当者が変わっても止まらない」状態に近づけていきます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 bg-gradient-to-br from-[#12335f] to-[#153577] rounded-2xl p-10 lg:p-12 text-center shadow-lg relative overflow-hidden">
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
            <div className="relative z-10">
              <p className="text-base lg:text-lg text-white leading-loose">
                すべてを一度に進める必要はありません。<br />
                状況や課題に合わせて、<br />
                <strong className="font-bold">必要なステップから伴走します。</strong>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
